var store = require("store");
import swiper from "swiper";
import { TweenMax } from "gsap/TweenMax";

//　トップページでアニメーション再生するか判断
var isTopPage = -1 < $.inArray(location.pathname, ["/", "/index.php"]);
var pathname = function () {
  return location.pathname == "/index.php" ? "/" : location.pathname;
};

if (isTopPage) {
  // ==================================================
  // 外部からこのサイトを訪問したユーザーには必ずアニメーションを見せる
  // いちどアニメーションを見せたらサイト内部を回遊している間はアニメーションを見せない
  // ※トップページでリロードした場合は、アニメーションを見せる
  // ==================================================
  var fromOutside = !document.referrer.match(location.host);

  if (fromOutside) {
    store.set("referrer", location.pathname);
  }

  if (pathname() == store.get("referrer")) {
    $("body").data("animate", true);
    console.log($("body").data("animate", true));
    setTimeout(function () {
      //バナー表示
      showElementAnimation();
    }, 4000);
  } else {
    $(".top-opening").remove();
    showElementAnimation();
  }
  if ($(".top-opening").css("display") == "block") {
    $(".top-opening").css("display", "none");
  }
}

store.set("referrer", pathname());

if ($(".js-c-sliderHer0").length) {
  var serviseNavHer0 = new swiper(".js-c-sliderHer0", {
    init: false,
    direction: "horizontal",
    loop: true,
    autoplay: {
      delay: 4000,
    },
    speed: 2000,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoHeight: true,
    slidesPerView: 1,
    breakpoints: {
      960: {
        slidesPerView: 1,
      },
      414: {
        autoHeight: false,
        slidesPerView: 1,
      },
    },
  });

  if (!$(".ua-ie").length) {
    //トップページに記述する
    if ($("body").data("animate")) {
      $(".top-opening").css("display", "block");
      $("body").css("position", "fixed");
      $("#opening-base").on("webkitAnimationEnd", () => {
        //.anm_spinのアニメーション終了時の処理
        new TimelineMax()
          .to(".top-opening", 0.4, { y: "0", alpha: 0 })
          .to(".top-opening", 0.1, { display: "none" })
          .to("body", 0.1, { position: "static" });
        serviseNavHer0.init();
      });
      //実行したいものを書く
    } else {
      serviseNavHer0.init();
    }
  } else {
    serviseNavHer0.init();
  }
}

/*---------------------
  バナーを表示させる処理
 ----------------------*/
function showElementAnimation() {
  var element = document.getElementsByClassName("js-banner-animation");
  if (!element) return; // 要素がなかったら処理をキャンセル
  $(".js-banner-animation").addClass("is-show");
}

function bannerClose() {
  $(".js-banner-animation").removeClass("is-show");
  $(".js-banner-reduced").addClass("is-show");
}

function bannerIn() {
  $(".js-banner-reduced").removeClass("is-show");
  $(".js-banner-animation").addClass("is-show");
}

$(".c-bannner-close").click(function () {
  bannerClose();
});

$(".c-bannner-reduced").click(function () {
  bannerIn();
});
